import React from 'react'
import { Formik, Form } from 'formik'
import { Button, Form as OIOForm, Grid, GridCell,
   Input, Select, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import CloseIcon from 'assets/icons/close'

const DiscountCreate = ({ onCloseButtonClick }) => {
   const handleSubmit = async (values, actions) => {
      actions.setSubmitting(false)
   }

   return (
      <View
         borderRadius="6px[c-f]"
         style={{ overflow: 'hidden' }}
         float="left"
         width="100%"
         height="100%">
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            float="left"
            width="100%"
            height="54px"
            padding="0px 18px"
            borderBottom="1px solid #eee">
            <Text weight="medium">
               Create Discount
            </Text>
            <View
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               onClick={onCloseButtonClick}>
               <CloseIcon width="24px" height="24px" />
            </View>
         </View>
         <View
            display="flex"
            float="left"
            width="100%"
            height="calc(100% - 54px)[c-f]"
            borderBottom="1px solid #eee[a-b]"
            borderRight="1px solid #eee[c-f]"
            padding="18px">
            <Formik
               onSubmit={handleSubmit}
               render={({ isSubmitting }) => (
                  <Form>
                     <OIOForm elementAppearance="plain" elementBackgroundColor="#eee">
                        <Grid columns="12">
                           <GridCell colspan="12">
                              <Input label="Discount Name" />
                           </GridCell>
                           <GridCell colspan="12">
                              <Select label="Discount Applies to">
                                 <option value="">Initiative Name</option>
                              </Select>
                           </GridCell>
                           <GridCell colspan="6">
                              <Select label="Discount Type">
                                 <option value="">(%) Percentage</option>
                                 <option value="">($) Fixed Amount</option>
                              </Select>
                           </GridCell>
                           <GridCell colspan="6">
                              <Input label="Discount Value" />
                           </GridCell>
                           <GridCell colspan="6">
                              <Input label="Discount Code" />
                           </GridCell>
                           <GridCell colspan="6">
                              <Input label="Quantity Available" />
                           </GridCell>
                           <GridCell colspan="12">
                              <View textAlign="center">
                                 <Text size="1" color="#888">
                                    {'If discount code field is left blank, a code will be automatically generated.'}
                                 </Text>
                              </View>
                           </GridCell>
                           <GridCell colspan="12">
                              <Button
                                 type="submit"
                                 name="Create Discount"
                                 width="100%"
                                 size="md"
                                 mode={isSubmitting ? 'loading' : 'normal'}
                              />
                           </GridCell>
                        </Grid>
                     </OIOForm>
                  </Form>
               )}
            />
         </View>
      </View>
   )
}

DiscountCreate.propTypes = {
   onCloseButtonClick: PropTypes.func.isRequired
}

export default DiscountCreate
